import {
  EDIT_USUARIO,
  FETCH_USUARIO,
  FETCH_USUARIOS,
  SET_FILTRO_USUARIOS,
  FETCH_TOKEN_RESET_PASSWORD,
  LOADING_USUARIOS,
  UPDATE_LIST_USUARIOS,
  RESET_FILTRO_USUARIO,
  RESET_USUARIO,
  FETCH_TIPOS_USUARIOS,
  FETCH_ACCIONES_TIPO_USUARIO,
  FETCH_ACCIONES,
} from './types';
import {
  postSearchUsuario,
  obtenerUsuariosDeSeller,
  requestTokenResetPassword,
  getTiposUsuarios,
  getAccionesPredefinidasTipoUsuarioApi,
  getAccionesApi
} from '../api/axios';

export const userTypeIds = {
  isCategory: 1,
  isAdminMod: 2,
  isSellerAdmin: 3,
  isSeller: 4,
  isResetPassword: 5,
  isSoloLectura: 6,
  isProveedor: 7,
  isContaduria: 8,
  isTesoreria: 9,
}

export const getUserTypes = (tipoUsuario) => {
  return Object.keys(userTypeIds).reduce((previous, userType) => ({
    ...previous,
    [userType]: userTypeIds[userType] == tipoUsuario,
  }), {})
};

export const editUsuario = (usuario) => dispatch => {
  dispatch({
    type: EDIT_USUARIO,
    payload: usuario
  });
};

export const setFiltroUsuarios = (params) => dispatch => {
  return new Promise((resolve) => {
    dispatch({
      type: SET_FILTRO_USUARIOS,
      payload: params
    });
    resolve();
  });
};

export const resetFiltroUsuario = () => dispatch => {
  dispatch({
    type: RESET_FILTRO_USUARIO,
    payload: []
  });
};

export const resetUsuario = () => dispatch => {
  dispatch({
    type: RESET_USUARIO,
    payload: []
  });
};



export const fetchTokenResetPassword = (params) => async (dispatch) => {
  try {
    const payload = await requestTokenResetPassword(params);
    dispatch({
      type: FETCH_TOKEN_RESET_PASSWORD,
      token: payload,
    });
    return payload;
  } catch (error) {
    throw error;
  }
};


export const fetchUsuarios = (params) => async dispatch => {
  dispatch({
    type: LOADING_USUARIOS,
    payload: true
  });

  let response = obtenerUsuariosDeSeller(params);
  let usuarios;

  response.then(function (value) {
    const { elementos, cantidadTotal, cantidadPagina } = value.data;

    usuarios = elementos;
    usuarios["cantidadTotal"] = cantidadTotal;
    usuarios["cantidadPagina"] = cantidadPagina;

    dispatch({
      type: FETCH_USUARIOS,
      payload: usuarios
    });

    dispatch({
      type: LOADING_USUARIOS,
      payload: false
    });
  });
};

export const fetchUsuario = (data) => async dispatch => {
  let usuario = postSearchUsuario(data);

  usuario.then(function (value) {
    let user = value.data;
    dispatch({
      type: FETCH_USUARIO,
      payload: user
    });
  }).catch(error => {
    console.warn("Error fetching usuario:", error);
    // Optionally dispatch an error state or reset user
    dispatch({
      type: FETCH_USUARIO,
      payload: {} // Ensure payload is empty so fallback works
    });
  });
};

export const updateListUsuarios = (usuariosArray, userUpdated) => (dispatch, getState) => {
  const { cantidadTotal, cantidadPagina } = getState().usuarios;

  const usuariosActualizados = usuariosArray.map((item) => {
    if (item.idUsuario === userUpdated.idUsuario) {
      return {
        ...item,
        email: userUpdated.email,
        fechaAlta: userUpdated.fechaAlta,
        fechaUltimoLogin: userUpdated.fechaUltimoLogin,
        moderador: userUpdated.moderador,
        nombreUsuario: userUpdated.usuario,
      };
    }
    return item;
  });

  dispatch({
    type: UPDATE_LIST_USUARIOS,
    payload: {
      usuarios: usuariosActualizados,
      cantidadTotal,
      cantidadPagina,
    },
  });
};

export const fetchTipoUsuarios = (id = null) => async (dispatch) => {
  try {

    const response = await getTiposUsuarios(id);

    dispatch({
      type: FETCH_TIPOS_USUARIOS,
      payload: response,
    });

    return response;

  } catch (error) {
    throw error;
  }
};

export const fetchAccionesTipoUsuario = (idTipoUsuario) => async dispatch => {
  try {
    const response = await getAccionesPredefinidasTipoUsuarioApi(idTipoUsuario);

    dispatch({
      type: FETCH_ACCIONES_TIPO_USUARIO,
      payload: response.data
    });

    return response.data;
  } catch (error) {
    console.error("Error cargando acciones:", error);
    throw error;
  }
};

export const fetchAcciones = (idAccion) => async dispatch => {
  try {
    const response = await getAccionesApi(idAccion);

    dispatch({
      type: FETCH_ACCIONES,
      payload: response.data
    });

    return response.data;
  } catch (error) {
    console.error("Error cargando acciones:", error);
    throw error;
  }
};
